import { FormalizeCandidate, FormalizeCompany, FormalizeJobMatch, FormalizeRequisition } from 'src/app/public/app/models/formalizePayload';
class ConferenceController {
    /*@ngInject*/
    constructor($rootScope, $timeout, $uibModal, $filter, moment, companyService, jobMatchService, meetingService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$uibModal = $uibModal;
        this.$filter = $filter;
        this.moment = moment;
        this.companyService = companyService;
        this.jobMatchService = jobMatchService;
        this.meetingService = meetingService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        this.isLoading = true;
        this._setContext();
        this.$rootScope.hideNav = true;
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.isCorporate = this.companyService.isCorporateCompany();
        this.participantName = this.$rootScope.userDetails.firstname + ' ' + this.$rootScope.userDetails.lastname;
        this.isLoadingMeetingLink = true;
        if (this.context !== 'candidateCard') {
            if (this.scheduleId) {
                this._getScheduledMeetingDetails((data) => {
                    this._getCandidateJobMatchInfo(() => {
                        this.scheduleInfo = this.meetingService.getMassagedMeetingDetails(data);
                        this.isLoading = false;
                    }, error => {
                        this.isLoading = false;
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                });
            }
            else if (this.workflowStep == 'rs') {
                this._getCandidateJobMatchInfo(() => {
                    this.isLoading = false;
                }, error => {
                    this.isLoading = false;
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
        }
    }
    _setContext() {
        if (this.jobMatchId) {
            this.context = "candidateJobMatchCard";
        }
        else if (this.candidateId) {
            this.context = "candidateCard";
            this.isLoading = false;
        }
        else {
            this.context = "schedule";
        }
        this.displayAllSchedule = false;
        if (this.jobMatchId && (this.workflowStep === 'ps' || this.workflowStep == 'in')) {
            this.displayAllSchedule = true;
        }
    }
    _getCandidateJobMatchInfo(successCallback, errorCallback) {
        this.isLoading = true;
        this.jobMatchService.getCandidateJobMatchCard(this.jobMatchId, this.companyId, (data) => {
            this.candidateJobMatch = data;
            this.candidateJobMatch.name = data.firstName + ' ' + data.lastName;
            this.candidateId = data.id;
            this.jobId = data.jobMatchJobId;
            this.setFormalizeActivityPayload();
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            if (errorCallback) {
                errorCallback();
            }
        });
    }
    _getScheduledMeetingDetails(successCallback) {
        this.jobMatchService.getMeetingDetails(this.scheduleId, (data) => {
            this.candidateId = data.candidateDetail.id;
            this.jobId = data.jobId;
            this.jobMatchId = data.jobMatchId;
            if (successCallback) {
                successCallback(data);
            }
        }, (error) => {
            this.isLoading = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    setFormalizeActivityPayload() {
        this.formalizeActivityPayload = {
            candidate: new FormalizeCandidate(this.candidateId, this.candidateJobMatch.firstName, this.candidateJobMatch.lastName),
            requisition: new FormalizeRequisition(this.jobId, this.candidateJobMatch.jobMatchRequisitionNum, this.candidateJobMatch.jobMatchTitle),
            jobMatch: new FormalizeJobMatch(this.candidateJobMatch.jobMatchId, this.jobId, this.candidateJobMatch.jobMatchRequisitionNum, this.candidateJobMatch.jobMatchTitle),
            company: new FormalizeCompany(this.companyId, this.candidateJobMatch.currentJobCompanyName, this.candidateJobMatch.clientOrBUId, this.candidateJobMatch.clientOrBUName)
        };
    }
}
ConferenceController.$inject = ['$rootScope', '$timeout', '$uibModal', '$filter', 'moment', 'companyService', 'jobMatchService', 'meetingService', 'alertsAndNotificationsService'];
import * as TEMPLATE from 'raw-loader!./conference.html';
export const ConferenceComponent = {
    selector: 'conference',
    component: {
        bindings: {
            scheduleId: '@',
            candidateId: '@',
            jobId: '@',
            jobMatchId: '@',
            workflowStep: '@',
            type: '@',
            mode: '@'
        },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/conference/conference/conference.html',
        controller: ConferenceController
    }
};
//# sourceMappingURL=conference.component.js.map